<template>
    <svg 
        v-if="direction === 'right'" 
        :width="size" 
        :height="size * 1.75" 
        :viewBox="[`0 0 ${size} ${size * 1.75}`]" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
    >
        <path 
            fill-rule="evenodd" 
            clip-rule="evenodd"
            d="M1.06866 13.6334C0.684571 13.3261 0.622297 12.7657 0.929571 12.3816L5.23448 7.00045L0.929571 1.61932C0.622297 1.23523 0.684571 0.674767 1.06866 0.367494C1.45276 0.0602188 2.01322 0.122493 2.32049 0.506585L7.07049 6.44409C7.33071 6.76936 7.33071 7.23155 7.07049 7.55682L2.32049 13.4943C2.01322 13.8784 1.45276 13.9407 1.06866 13.6334Z" 
            :fill="color"
        />
    </svg>
    <svg 
        v-else
        :width="size" 
        :height="size * 1.75" 
        :viewBox="[`0 0 ${size} ${size * 1.75}`]"
        fill="none" xmlns="http://www.w3.org/2000/svg"
    >
        <path 
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.93134 0.367071C7.31543 0.674346 7.3777 1.23481 7.07043 1.6189L2.76552 7.00003L7.07043 12.3812C7.3777 12.7653 7.31543 13.3257 6.93134 13.633C6.54724 13.9403 5.98678 13.878 5.67951 13.4939L0.929505 7.5564C0.669286 7.23113 0.669286 6.76894 0.929505 6.44366L5.67951 0.506164C5.98678 0.122071 6.54724 0.0597974 6.93134 0.367071Z" 
            :fill="color"
        />
    </svg>
</template>

<script>
export default {
    props: {
        color: {
            type: String,
            default: '#FFF'
        },
        size: {
            type: Number,
            default: 8
        },
        direction: {
            validator: function (value) {
                return ['right', 'left'].includes(value)
            }
        }
    }
}
</script>
